export const SUPPORT = {
    ottry: {
        formatted: '+38 (097) 938-11-62',
        number: '+380979381162'
    },
    default : {
        formatted: '0-800-33-56-89',
        number: '0800335689'
    },
};

export const IMPULSE_STATUS_GENERALIZED = {
    0: 'pending',
    1: 'pending',
    2: 'pending',
    3: 'pending',
    4: 'success',
    5: 'error',
    6: 'error'
};